<!--
<h1 mat-dialog-title>Logs</h1>
<div mat-dialog-content>
    <ng-container *ngFor="let log of logs">
        <span [ngClass]="{'error-log': log.includes('error')}">{{ log }}</span>
      </ng-container>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onClose()">Close</button>
</div>
-->

<div class="dialog-wrapper">
    <div class="d-flex justify-content-between">
        <h1>{{'documents.titles.import_history' | translate:{country: country_name} }} </h1>
    </div>
    <div class="espace"></div>
    <div>{{title}}</div>
    <div class="espace"></div>

    <div mat-dialog-content>
        <table mat-table [dataSource]="history" class="mat-elevation-z8 log-table">

            <!-- Line Column -->
            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef> date </th>
                <td mat-cell *matCellDef="let item" > {{ item.created_at | date:'short' }} </td>
            </ng-container>

            <!-- Line Column -->
            <ng-container matColumnDef="userid">
                <th mat-header-cell *matHeaderCellDef> UserId </th>
                <td mat-cell *matCellDef="let item" > {{item.user_id}} </td>
            </ng-container>

            <!-- Email Column -->
            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef> Email </th>
                <td mat-cell *matCellDef="let item" > {{item.email}} </td>
            </ng-container>
            

            <!-- Status Column -->
            <ng-container matColumnDef="filename">
                <th mat-header-cell *matHeaderCellDef> Filename </th>
                <td mat-cell *matCellDef="let item" > {{item.filename}} </td>
            </ng-container>

            <ng-container matColumnDef="logs">
                <th mat-header-cell *matHeaderCellDef> Logs </th>
                <td mat-cell *matCellDef="let item" >
                    <a (click)="onOpenLogs(item)">
                        <mat-icon>visibility</mat-icon>
                    </a>
                </td>
            </ng-container>

    
            <ng-container matColumnDef="download">
                <th mat-header-cell *matHeaderCellDef> Download </th>
                <td mat-cell *matCellDef="let item" >
                    <a (click)="onDownload(item)">
                        <mat-icon>file_download</mat-icon>
                    </a>
                </td>
            </ng-container>

            <!-- Message Column 
            <ng-container matColumnDef="message">
                <th mat-header-cell *matHeaderCellDef> Message </th>
                <td mat-cell *matCellDef="let item" [ngClass]="{'error-log': log.status === 'error'}"> {{log.message}} </td>
            </ng-container>
-->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
       
    </div>
    <div class="espace"></div>
   
        <button mat-stroked-button color="primary" (click)="onClose()">
            {{ 'general.ok' | translate }}
        </button>
   


</div>